import {clsx} from 'clsx'

import {ProjectIcon, SearchIcon, ShieldIcon} from '@primer/octicons-react'
import {Link, Stack, Text} from '@primer/react-brand/esm'

import type {MarketingHeaderTitle} from '../../marketing-header.types'
import styles from './MobileHeaderTitle.module.css'

type MobileHeaderTitleProps = {
  isMenuOpen: boolean
  title: MarketingHeaderTitle
}

function renderTitleContent(title: MarketingHeaderTitle) {
  switch (title.kind) {
    case 'text':
      return (
        <Text className={styles.text} weight="semibold">
          {title.text}
        </Text>
      )
    case 'link':
      return (
        <Link arrowDirection="none" className={styles.content} href={title.href}>
          <Text className={styles.text} weight="semibold">
            {title.text}
          </Text>
        </Link>
      )
    case 'icon-text': {
      const Icon = title.icon === 'project' ? ProjectIcon : ShieldIcon

      return (
        <Stack alignItems="center" className={styles.content} direction="horizontal" gap={4}>
          <Icon className={styles.icon} aria-hidden="true" />
          <Text className={styles.text} weight="semibold">
            {title.text}
          </Text>
        </Stack>
      )
    }
    case 'icon-only':
      return (
        <span className={styles.content} role="img" aria-label={title.accessible_label}>
          <SearchIcon className={styles.icon} aria-hidden="true" />
        </span>
      )
  }
}

export function MobileHeaderTitle({isMenuOpen, title}: MobileHeaderTitleProps) {
  return (
    <Stack
      alignItems="center"
      className={clsx(styles.title, isMenuOpen && styles.menuOpen)}
      direction="horizontal"
      justifyContent="center"
    >
      {renderTitleContent(title)}
    </Stack>
  )
}

MobileHeaderTitle.displayName = 'MobileHeaderTitle'
